// Google Analytics 4 (gtag) — le script est chargé dans public/index.html.
// On ne track jamais de PII (nom, téléphone, email) dans les événements,
// uniquement des identifiants non sensibles (id de réservation Firestore,
// aléatoire et non devinable) et des données déjà publiques (nom de
// résidence, ville, montants).
export const trackEvent = (eventName, params) => {
  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    window.gtag('event', eventName, params);
  }
};

export const analytics = {
  // Visiteur consulte une résidence
  voirResidence: (residenceNom, ville) => {
    trackEvent('view_residence', {
      residence_name: residenceNom,
      ville: ville,
    });
  },

  // Visiteur fait une recherche
  recherche: (ville, type, budget) => {
    trackEvent('search', {
      search_term: ville,
      type_logement: type,
      budget: budget,
    });
  },

  // Visiteur initie une réservation
  reservationInitiee: (residenceNom, montant) => {
    trackEvent('begin_checkout', {
      residence_name: residenceNom,
      value: montant,
      currency: 'XOF',
    });
  },

  // Réservation confirmée
  reservationConfirmee: (reservationId, montant, ville) => {
    trackEvent('purchase', {
      transaction_id: reservationId,
      value: montant,
      currency: 'XOF',
      ville: ville,
    });
  },

  // Nouvelle inscription client
  inscriptionClient: (ville) => {
    trackEvent('sign_up', {
      method: 'email',
      role: 'client',
      ville: ville,
    });
  },

  // Nouvelle inscription gérant
  inscriptionGerant: (ville) => {
    trackEvent('sign_up', {
      method: 'email',
      role: 'gerant',
      ville: ville,
    });
  },
};
